module.exports = __webpack_public_path__ + "static/media/LoadNowIcon.4696463b.svg";